export default __webpack_public_path__ + "static/media/newvid.54834b4e.mp4";